<div>
  <ng-container *ngTemplateOutlet="listContent"></ng-container>
</div>

<!-- List Content -->
<ng-template #listContent>
  <ng-content></ng-content>
</ng-template>
